import { createInitializeOnce } from './utilities';

const initializeOnce = createInitializeOnce();

export default function setupTabFocus() {
    if (!initializeOnce(document)) return;

    // Prevents focus indicators on mouse click, but leaves them active for keyboard tabs
    document.addEventListener('mousedown', () => {
        document.documentElement.classList.remove('show-focus');
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
            document.documentElement.classList.add('show-focus');
        }
    });
}
